<template>
  <el-menu class="navbar" mode="horizontal">
    <!-- 汉堡菜单 -->
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>

    <!-- 中间占位 -->
    <div class="spacer"></div>

    <!-- 账户余额（实时更新） -->
    <div class="account-balance" @click="getUmsAdmin">
      <el-tooltip
        effect="dark"
        content="点击刷新账户余额"
        placement="bottom"
        popper-class="balance-tooltip"
      >
        <div class="balance-content">
          <i class="el-icon-money"></i>
          <span>账户余额：{{ umsAdmin.accountBalance || 0 }}豆</span>
        </div>
      </el-tooltip>
    </div>

    <!-- 下拉菜单 -->
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper" style="cursor: pointer">
        <div class="user-info">
          <img class="user-avatar" :src="userImg" />
          <span class="user-text">{{ name }}</span>
        </div>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>首页</el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display: block">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <div class="zww"></div>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
import userImg from "@/assets/images/user.png";
import { getUmsAdminMessage } from "@/api/rechargeRecord";

const defaultUserAdmin = {
  accountBalance: 0, // 初始化避免空值
};

export default {
  data() {
    return {
      userImg,
      umsAdmin: Object.assign({}, defaultUserAdmin),
      webSocket: null, // WebSocket实例
      reconnectTimer: null, // 重连定时器
      reconnectInterval: 3000, // 重连间隔（3秒）
      timeL: null,
      tLen: 0,
    };
  },
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "name"]),
  },
  created() {
    // 初始化余额
    this.getUmsAdmin();
    // 延迟初始化WebSocket（等待用户名加载）
    // this.$nextTick(() => {
    //   this.name ? this.initWebSocket() : setTimeout(() => this.initWebSocket(), 1000);
    // });
  },
  beforeDestroy() {
    // 组件销毁关闭WebSocket
    this.closeWebSocket();
  },
  methods: {
    // ---------------------- WebSocket核心方法 ----------------------
    /**
     * 初始化WebSocket（自动适配wss/ws）
     */
    initWebSocket() {
      if (!this.name) {
        console.warn("用户名未加载，无法建立WebSocket连接");
        return;
      }
      // 关闭旧连接
      if (this.webSocket) {
        this.webSocket.close(1000, "重新连接");
      }

      // HTTPS用wss，HTTP用ws
      const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
      // const host = window.location.host;
      // const host = "localhost:8080";
      // const host = "121.43.97.86:8080";
      const host = "xingbaogao.com";
      // const host = "120.27.162.209:8080";
      const wsUrl = `${protocol}//${host}/ws/balance/${this.name}`;

      console.log(`WebSocket连接中：${wsUrl}`);
      this.webSocket = new WebSocket(wsUrl);

      // 连接成功
      this.webSocket.onopen = () => {
        console.log("WebSocket连接成功✅");
        clearInterval(this.reconnectTimer);
        this.reconnectTimer = null;
      };

      // 接收消息（实时更新余额）
      this.webSocket.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.accountBalance !== undefined) {
            this.umsAdmin.accountBalance = data.accountBalance;
          }
        } catch (err) {
          console.error("解析WebSocket消息失败：", err);
        }
      };

      // 连接关闭（自动重连）
      this.webSocket.onclose = (e) => {
        console.log(`WebSocket关闭（码：${e.code}）❌`);
        // 非主动关闭则重连
        // if (e.code !== 1000) {
        //   this.reconnectTimer = setInterval(() => this.initWebSocket(), this.reconnectInterval);
        // }
      };

      // 连接错误
      this.webSocket.onerror = (err) => {
        console.error("WebSocket错误：", err);
        this.webSocket.close();
      };
    },

    /**
     * 关闭WebSocket
     */
    closeWebSocket() {
      if (this.webSocket) {
        this.webSocket.close(1000, "组件销毁/用户退出");
        this.webSocket = null;
      }
      if (this.reconnectTimer) {
        clearInterval(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },

    // ---------------------- 原有业务方法 ----------------------
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
      // const dom = document.getElementById("doCloseMenu");
      // if (dom) {
      //   dom.ontouchstart = () => {
      //     this.$store.dispatch("ToggleSideBarCLose");
      //     dom.ontouchstart = null;
      //   };
      // }
      if (window.resetChart) {
        if (this.timeL) {
          clearInterval(this.timeL);
          this.tLen = 0;
        }
        this.timeL = setInterval(() => {
          window.resetChart();
          if (this.tLen++ > 100) {
            if (this.timeL) {
              clearInterval(this.timeL);
              this.tLen = 0;
            }
          }
        }, 10);
      }
    },

    logout() {
      // 退出时关闭WebSocket
      this.closeWebSocket();
      this.$store.dispatch("LogOut").then(() => {
        location.reload();
      });
    },

    getUmsAdmin() {
      // 保留手动刷新（兜底）
      getUmsAdminMessage().then((res) => {
        this.umsAdmin = res.data;
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 33px;
  border-radius: 0 !important;
  position: relative;
  display: flex;
  align-items: center;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    padding: 0 10px;
    flex-shrink: 0;
  }

  .spacer {
    flex: 1;
  }

  .account-balance {
    white-space: nowrap;
    color: #606266;
    font-size: 14px;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 8px;
    flex-shrink: 0;

    .balance-content {
      display: flex;
      align-items: center;
      background-color: #44a7ff;
      border-radius: 32px;
      color: #fff;
      padding: 0 16px;

      .el-icon-money {
        margin-right: 4px;
        color: #fff !important;
      }
    }
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    flex-shrink: 0;
    margin-top: 6px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-info {
        display: flex;
        align-items: center;
        background-color: #8fcc72;
        border-radius: 32px;
        padding: 0 16px 0 8px;
      }

      .user-avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-right: 4px;
      }

      .user-text {
        margin-left: 5px;
        vertical-align: middle;
        color: #fff;
      }
    }
  }
}

.zww {
  width: 20px;
}

::v-deep .balance-tooltip {
  background: #333 !important;
  color: #fff !important;
  border-radius: 4px !important;
  padding: 5px 10px !important;
  font-size: 12px !important;
  box-shadow: none !important;

  &::after {
    border-bottom-color: #333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue